import produce from 'immer';
import { get } from 'lodash';
import {
  GET_ORDER_SUCCESS,
  HANDLE_MODAL_SHOW,
  HANDLE_MODAL_CANCEL,
  POST_ORDER_REQUEST,
  POST_ORDER_SUCCESS,
  POST_ORDER_FAILURE,
  PUT_ORDER_REQUEST,
  PUT_ORDER_SUCCESS,
  PUT_ORDER_FAILURE,
  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAILURE,
  ON_CHANGE_FIELD,
  ON_CHANGE_FILTER,
  FILTER_DATE_ENUM,
  ON_CHANGE_ADD_PHOTO,
  ON_CHANGE_DEL_PHOTO,
  ORDER_STATUS_ENUM,
  GET_ORDER_ITEM_SUCCESS,
  POST_ORDER_ITEM_REQUEST,
  POST_ORDER_ITEM_SUCCESS,
  POST_ORDER_ITEM_FAILURE,
} from './order.constants';

export const initialState = {
  orderList: [],
  orgOrderList: [],
  filter: {
    date: { type: 'relative', value: FILTER_DATE_ENUM.ALL },
    note: '',
    createdBy: 0,
    status: ORDER_STATUS_ENUM.PENDING,
  },
  postForm: {
    photo: [],
  },
  postLoading: false,
  postError: false,
  modalVisible: false,
  modalOrderId: 0,
  updateStatusLoading: false
};

/* eslint-disable default-case, no-param-reassign */
const orderReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { orderList, orgOrderList } = draft;
    switch (action.type) {
      case GET_ORDER_SUCCESS: {
        const data = action.payload;
        draft.orderList = data;
        draft.orgOrderList = data;
        console.log(data);
        break;
      }
      case POST_ORDER_REQUEST: {
        draft.postLoading = true;
        break;
      }
      case POST_ORDER_SUCCESS: {
        draft.postLoading = false;
        draft.postForm = {
          photo: [],
        };
        break;
      }
      case POST_ORDER_FAILURE: {
        draft.postLoading = false;
        break;
      }
      case HANDLE_MODAL_SHOW: {
        draft.modalVisible = true;
        draft.modalOrderId = action.payload;
        break;
      }
      case HANDLE_MODAL_CANCEL: {
        draft.modalVisible = false;
        break;
      }

      case PUT_ORDER_REQUEST: {
        const { id } = action.payload;
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          item.loading = true;
          delete item.error;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case PUT_ORDER_SUCCESS: {
        const order = action.payload;
        const ind = orderList.findIndex(x => x.id === order.id);
        if (ind > -1) {
          draft.orderList = [...orderList.slice(0, ind), { ...order }, ...orderList.slice(ind + 1)];
        }
        const orgInd = orgOrderList.findIndex(x => x.id === order.id);
        if (orgInd > -1) {
          draft.orgOrderList = [...orgOrderList.slice(0, orgInd), { ...order }, ...orgOrderList.slice(orgInd + 1)];
        }
        break;
      }
      case PUT_ORDER_FAILURE: {
        const { id, error } = action.payload;
        const errorMessage = get(error, 'response.data.error', error.toString());
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          delete item.loading;
          item.error = errorMessage;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case DELETE_ORDER_REQUEST: {
        const { id } = action.payload;
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          item.loading = true;
          delete item.error;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case DELETE_ORDER_SUCCESS: {
        const { id } = action.payload;
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          draft.orderList = [...orderList.slice(0, ind), ...orderList.slice(ind + 1)];
        }
        break;
      }
      case DELETE_ORDER_FAILURE: {
        const { id, error } = action.payload;
        const errorMessage = get(error, 'response.data.error', error.toString());
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          delete item.loading;
          item.error = errorMessage;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }

      case ON_CHANGE_FIELD: {
        const { fieldName, fieldValue } = action.payload;
        const itemInd = orderList.findIndex(x => x.id === action.payload.id);
        if (itemInd > -1) {
          const item = orderList[itemInd];
          item[fieldName] = fieldValue;
          draft.orderList = [...orderList.slice(0, itemInd), { ...item }, ...orderList.slice(itemInd + 1)];
        }
        break;
      }
      case ON_CHANGE_FILTER: {
        const { fieldName, fieldValue } = action.payload;
        let filterValue = fieldValue;
        if (fieldName === 'date') {
          const [type, value] = fieldValue.split(',');
          filterValue = { type, value };
        }
        draft.filter[fieldName] = filterValue;
        break;
      }
      case ON_CHANGE_ADD_PHOTO: {
        draft.postForm.photo = [action.payload];
        break;
      }
      case ON_CHANGE_DEL_PHOTO: {
        draft.postForm.photo = [];
        break;
      }
      case GET_ORDER_ITEM_SUCCESS: {
        const { id, list } = action.payload
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          item.logLoading = false;
          item.logs = list;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case POST_ORDER_ITEM_REQUEST: {
        const { id } = action.payload
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          item.logLoading = true;
          item.logError = false;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case POST_ORDER_ITEM_SUCCESS: {
        const order = action.payload
        const ind = orderList.findIndex(x => x.id === order.id);
        if (ind > -1) {
          draft.orderList = [...orderList.slice(0, ind), { ...order }, ...orderList.slice(ind + 1)];
        }
        break;
      }
      case POST_ORDER_ITEM_FAILURE: {
        const { id, error } = action.payload
        const ind = orderList.findIndex(x => x.id === id);
        if (ind > -1) {
          const item = orderList[ind];
          item.logLoading = false;
          item.logError = error;
          draft.orderList = [...orderList.slice(0, ind), { ...item }, ...orderList.slice(ind + 1)];
        }
        break;
      }
    }
  });

export default orderReducer;
